import {useRoutes} from "react-router-dom";
import {LoadComponent} from "@loadComponent";
import {lazy} from "react";
import { $subTitle } from "_layout/Client/Header";

const Search = lazy(() => import('./Search'));
const List = lazy(() => import('./List'));
const View = lazy(() => import('./View'));

const Home = () => {
    $subTitle.set('Atendimento Virtual');
    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={Search}/>
        },
        {
            path: 'busca',
            element: <LoadComponent component={List}/>
        },
        {
            path: 'vara',
            element: <LoadComponent component={View}/>
        },
    ]);
};


export default Home;
